import { useCallback, useMemo, useState } from 'react';
import { CoordinationClient } from '@atlassian/jira-engagement/src/ui/coordination-client/index.tsx';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

export const useCoordinationClient = (epMessageId: string) => {
	// null means coordination client has not yet determined what that message status is
	// true means the message has started and should be shown
	// false means the message should not be shown for any reason
	const [hasMessageStarted, setHasMessageStarted] = useState<null | boolean>(null);
	const { cloudId } = useTenantContext();
	const { data: orgId } = useOrgId();

	const coordinationClient = useMemo(
		() => new CoordinationClient(cloudId, '/gateway/api', false, orgId),
		[cloudId, orgId],
	);

	const setEpMessageStarted = useCallback(async () => {
		const started = await coordinationClient.start(epMessageId);
		setHasMessageStarted(started);
	}, [epMessageId, coordinationClient]);

	const stopMessage = useCallback(async () => {
		setHasMessageStarted(false);
		await coordinationClient.stop(epMessageId);
	}, [epMessageId, coordinationClient]);

	return { hasMessageStarted, setEpMessageStarted, stopMessage };
};
